<template>
  <div class="billing-address-card">

    <div class="billing-address-card__row-two-col">
      <h2 class="billing-address-card__title">Billing Address</h2>
      <PencilSVG
        class="edit-button"
        aria-label="Edit Address"
        @click="$emit('edit')"
      />
    </div>

    <div class="billing-address-card__lines">
      <div class="billing-address-card__line-title">Address Line 1:</div>
      <div class="billing-address-card__line-value">{{ address.address_line_1 }}</div>

      <div class="billing-address-card__line-title">Address Line 2:</div>
      <div class="billing-address-card__line-value">{{ address.address_line_2 }}</div>

      <div class="billing-address-card__line-title">City:</div>
      <div class="billing-address-card__line-value">{{ address.city }}</div>

      <div class="billing-address-card__line-title">State:</div>
      <div class="billing-address-card__line-value">{{ address.state }}</div>

      <div class="billing-address-card__line-title">Zip:</div>
      <div class="billing-address-card__line-value">{{ address.zip }}</div>

      <div class="billing-address-card__line-title">Country:</div>
      <div class="billing-address-card__line-value">{{ address.country }}</div>
    </div>
  </div>
</template>

<script>

import PencilSVG from '@/assets/images/icons/pencil.svg'

export default {
  components: { PencilSVG },
  computed: {
    address() {
      return this.$store.getters['cards/getBillingAddressData']
    },
  },
}
</script>


<style lang="scss">

</style>
